module.exports = __webpack_public_path__ + "static/media/Torso_3.3fbbbc22.jpg";